import { render, staticRenderFns } from "./FitnessplanCreate.vue?vue&type=template&id=53c3e9a9&"
import script from "./FitnessplanCreate.vue?vue&type=script&lang=js&"
export * from "./FitnessplanCreate.vue?vue&type=script&lang=js&"
import style0 from "./FitnessplanCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports